import { combineReducers, createStore } from "@reduxjs/toolkit"
import orgStore from './modules/orgReducer'
import userStore from './modules/userReducer'
import { persistStore, persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

const reducer = combineReducers
({
    orgReducer: orgStore,
    userReducer: userStore
})

const storageConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: ['orgReducer', 'userReducer']
}

// 创建持久化 reducer
const persistedReducer = persistReducer(storageConfig, reducer)
// 创建、持久化 store
let store = createStore(persistedReducer)
let persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export {store, persistor}